import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

export type S3DestinationAuthMode = 'static' | 'assume-role' | 'default-chain';

export interface DispatchS3Destination {
  id: number;
  orgId: number;
  departmentId: number | null;
  label: string | null;
  bucket: string;
  baseDir: string | null;
  region: string;
  authMode: S3DestinationAuthMode;
  accessKey: string | null;
  secretKey: string | null;     // masked from API: ****xxxx
  roleArn: string | null;
  externalId: string | null;    // masked from API except on first create / mode switch
}

export const S3_DESTINATIONS_QUERY_KEY = ['clip-dispatch', 's3-destinations'] as const;

export const useDispatchS3DestinationsQuery = () =>
  useQuery({
    queryKey: S3_DESTINATIONS_QUERY_KEY,
    queryFn: async () => {
      const res = await get<DispatchS3Destination[]>('/v1.0/clip-dispatch/s3-destinations');
      return res.data;
    },
  });
